import React from 'react'
import { Button } from '@mui/material';
import styled from 'styled-components'

const ChipLabel = styled(({ label, onClick, ...props  }) => (
    <Button
      {...props}
      variant='outlined'
      onClick={onClick}
    >
      {label}
    </Button>
))`
  min-width: auto;
  border: ${({ border, theme }) => border ? border : `1px solid ${ theme.palette.colors.gray200 }`};
  border-radius: ${ ({borderRadius}) => borderRadius ? borderRadius : '18px'};
  background: ${ ({background, theme}) => background ? background : theme.palette.colors.gray100};
  color: ${ ({color, theme}) => color ? color : theme.palette.colors.black};
  line-height: ${ ({lineHeight}) => lineHeight ? lineHeight : '2rem'};
  margin: ${ ({margin}) => margin ? margin : '0' };

  :hover {
    color: ${({theme}) => theme.palette.colors.black};
  }
`;

export default React.memo(ChipLabel)